
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1.73 0.75"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M182.48 217.4a.59.59 0 111.18 0M182.54 217.13a.19.19 0 01.15.19v.08h.19v-.08a.19.19 0 01.38 0v.08h.19v-.08a.19.19 0 01.15-.19","transform":"translate(-182.03 -216.66)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M.58.35h.91M.54.41h.99M.47.55H1.6"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M183.12 216.92a.05.05 0 10-.05.05l.05-.05z","transform":"translate(-182.03 -216.66)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M182.55 216.84a.89.89 0 01.52-.16c.37 0 .68.2.68.45h-.15","transform":"translate(-182.03 -216.66)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M.65.29h-.6L.03.38h.53M.56.21H.1L.08.29h.5L.56.21zM.49.13H.17L.15.21h.36L.49.13zM.43.05h-.2L.21.13h.24L.43.05zM.08.38v.35h.36M1.71.47v.26"}})])
          )
        }
      }
    